import { render, staticRenderFns } from "./CategoriesCreate.vue?vue&type=template&id=7ac412d2&"
import script from "./CategoriesCreate.vue?vue&type=script&lang=js&"
export * from "./CategoriesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports